// Phones, tablets, smart TVs, consoles and wearables. iPadOS Safari reports a
// Macintosh user agent, so it counts as a desktop here.
const NON_DESKTOP_USER_AGENT =
  /Mobi|Android|iPhone|iPad|iPod|Silk|Kindle|PlayBook|BlackBerry|BB10|Windows Phone|SmartTV|SMART-TV|Tizen|Web0S|webOS|CrKey|HbbTV|AppleTV|PlayStation|Xbox|Nintendo/i

export const isDesktopBrowser = (userAgent = navigator.userAgent) =>
  !NON_DESKTOP_USER_AGENT.test(userAgent)

export type DesktopAppPlatform = 'mac' | 'windows'

/**
 * The platform the desktop app would install on from this browser, or null
 * where it can't be installed (phones, tablets, Linux, ChromeOS).
 */
export const getDesktopAppPlatform = (
  userAgent = navigator.userAgent,
  maxTouchPoints = navigator.maxTouchPoints ?? 0,
): DesktopAppPlatform | null => {
  if (!isDesktopBrowser(userAgent)) return null
  if (/Macintosh/i.test(userAgent)) {
    // iPadOS Safari reports a Mac user agent; only touch support tells it apart.
    return maxTouchPoints > 1 ? null : 'mac'
  }
  if (/Windows/i.test(userAgent)) return 'windows'
  return null
}
